import { render, staticRenderFns } from "./UOttawaLabExamPt22025.vue?vue&type=template&id=6c2b3f18&scoped=true&"
import script from "./UOttawaLabExamPt22025.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExamPt22025.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExamPt22025.vue?vue&type=style&index=0&id=6c2b3f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b3f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
